export enum Bs2TipoCliente {
  PESSOA_FISICA = 1,
  PESSOA_JURIDICA = 2,
}
